<template lang="pug">
  b-card
    b-card.no-shadow.bg-light.mb-3
      b-row.align-items-center
        b-col
          b-input-group(v-if="edit_name_enabled")
            b-form-input.bg-white(autocomplete="off", placeholder="Nombre", v-model.trim="reference_name")
            b-input-group-append
              b-button(variant="soft-primary", @click="emitUpdate")
                .d-flex.align-items-center
                  span.mr-1.d-none.d-md-inline-block.text-sm Guardar
                  save-icon.icon-sm
          .d-flex.align-items-center(v-else)
            h5.mb-0.d-inline-block {{ reference_name || 'Referencia sin nombre' }}
            edit3-icon.icon-md.hover-primary.pointer.text-secondary.ml-2(@click="edit_name_enabled = true")
        b-col(md="auto")
          b-form-row.mt-2.mt-md-0.justify-content-end.justify-content-md-start
            b-col(cols="auto")
              trash-2-icon.icon-md.hover-danger.pointer.text-secondary(v-if="$can('delete', 'faq-block')", @click="$emit('ref:destroy')")
    b-input-group.mb-4
      b-form-input.bg-white(placeholder="Valor a guardar" :value="messenger_url + text", readonly)
      b-input-group-append
        b-button(:id="'reference_' + reference_id", variant="primary", @click="copy")
          copy-icon.icon-md
        b-tooltip(:target="'reference_' + reference_id", triggers="focus click blur", ref="copy-tooltip") URL Copiada
    .d-flex.align-items-center.mb-3
      b-link.text-reset(v-b-toggle="'action_' + reference_id")
        h5.mb-0 Siguiente bloque
          chevron-down-icon.ml-1.icon-md
    b-collapse.mb-4(:id="'action_' + reference_id", visible)
      b-form-row
        b-col
          .d-flex.justify-content-md-end.align-items-center.mb-2.flex-wrap(v-if="!next_block_action")
            b-button.mr-2.my-1(variant="soft-success", size="sm", @click="openActionModal('next_block')")
              .d-flex.align-items-center
                plus-icon.icon-sm.mr-1
                span.mr-1 Agregar siguiente bloque
          div(v-if="next_block_action")
            block-connector(:next_block_id="next_block_action.external_id", @change="updateNextBlock")
            b-link.text-danger(@click="destroyAction(next_block_action)") Borrar conexión
          p.mb-0.text-help.text-center(v-else) No hay conexión a siguiente bloque
    .d-flex.align-items-center.mb-3
      b-link.text-reset(v-b-toggle="'attribute_' + reference_id")
        h5.mb-0 Guardar informaión de usuario
          chevron-down-icon.ml-1.icon-md
    b-collapse.mb-4(:id="'attribute_' + reference_id", visible)
      b-form-row
        b-col
          .d-flex.justify-content-md-end.align-items-center.mb-2.flex-wrap
            b-button.mr-2.my-1(variant="soft-success", size="sm", @click="openActionModal('user_attribute')")
              .d-flex.align-items-center
                plus-icon.icon-sm.mr-1
                span.mr-1 Agregar elemento
          p.mb-0.text-help.text-center(v-if="!reference_attributes.length") No hay elementos creados
          b-input-group.mb-2(v-for="(ref_attr, index) in reference_attributes", :key="index")
            b-form-select(v-model="ref_attr.external_id",)
              option(value="", disabled) -- Selecciona attributo --
              option(v-for="user_attr in user_attributes", :key="user_attr.user_attribute_id", :value="user_attr.user_attribute_id") {{user_attr.name}}
            b-form-input(placeholder="Valor a guardar", v-model="ref_attr.value")
            b-input-group-append
              b-button(:variant="ref_action_id ==  ref_attr.reference_action_id ? 'soft-secondary' : 'soft-primary'", @click="updateAction(ref_attr)", :disabled="ref_action_id ==  ref_attr.reference_action_id")
                b-spinner(small, variant="primary", v-if="ref_action_id ==  ref_attr.reference_action_id")
                save-icon.icon-sm(v-else)
            b-input-group-append
              b-button(:variant="ref_action_id ==  ref_attr.reference_action_id ? 'soft-secondary' : 'soft-danger'", @click="destroyAction(ref_attr)", :disabled="ref_action_id ==  ref_attr.reference_action_id")
                b-spinner(small, variant="primary", v-if="ref_action_id ==  ref_attr.reference_action_id")
                trash-2-icon.icon-sm(v-else)
    b-modal(v-model="action_modal", :title="new_action.type == 'user_attribute' ? 'Guardar información de usuario' : 'Conexión a siguiente bloque'" ok-title="Crear", ok-variant="primary", cancel-title="Cancelar", @ok="createAction")
      b-form(v-if="new_action.type == 'user_attribute'")
        b-form-group(label="Guardar en variable")
          b-form-select(v-model="new_action.external_id", :state="!!new_action.external_id ? null : (validated ? false : null)")
            option(:value="null", disabled) -- Seleccionar variable --
            option(v-for="user_attr in user_attributes", :key="user_attr.user_attribute_id", :value="user_attr.user_attribute_id") {{user_attr.name}}
        b-form-group(label="Valor")
          b-form-input(placeholder="Valor a guardar", v-model.trim="new_action.value", required, :state="!!new_action.value.length ? null : (validated ? false : null)")
      block-connector(v-else, :next_block_id="new_action.external_id", @change="new_action.external_id = $event.next_block_id")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const flowController = createNamespacedHelpers('flow')
const userAttributeController = createNamespacedHelpers('user_attribute')

export default {
  data () {
    return {
      ref_action_id: null,
      edit_name_enabled: false,
      reference_name: '',
      flow_id: '',
      action_modal: false,
      new_action: {
        type: 'user_attribute',
        value: '',
        external_id: null,
      },
      validated: false,
    }
  },
  props: {
    reference_id: {
      default: 0
    },
    text: {
      default: ''
    },
    Reference_Actions: {
      type: Array,
      default: function () {
        return []
      }
    },
    msn_external_id : {
      default: null,
    }
  },
  computed: {
    ...userAttributeController.mapState({
      user_attributes: state => state.user_attributes
    }),
    ...flowController.mapState({
      flows: state => state.flows
    }),
    next_block_action () {
      return this.Reference_Actions.find(a => a.type == 'next_block')
    },
    reference_attributes () {
      return this.Reference_Actions.filter(a => a.type == 'user_attribute')
    },
    messenger_url () {
      return this.msn_external_id ? 'https://m.me/' + this.msn_external_id + '?ref=' : ''
    }
  },
  methods: {
    ...mapActions(['reference/createAction', 'reference/updateAction', 'reference/deleteAction']),
    emitUpdate () {
      this.edit_name_enabled = false
      if(this.reference_name == this.text) return
      else if(!this.reference_name.length) {
        this.reference_name = this.text
        return
      }
      this.$emit('ref:update', {text: this.reference_name})
    },
    createAction (modal) {
      modal.preventDefault()
      if(!this.new_action.external_id) {
        this.validated = true
        return
      }
      if(this.new_action.type == 'user_attribute' && !this.new_action.value.length) {
        this.validated = true
        return
      }

      let self = this

      this['reference/createAction']({
        account_id: self.$route.params.account_id,
        reference_id: self.reference_id,
        ...self.new_action,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.Reference_Actions.push(res.resource)
            self.action_modal = false
          }
        }
      })
    },
    updateAction (reference_action) {
      let self = this
      this.ref_action_id = reference_action.reference_action_id

      this['reference/updateAction']({
        account_id: self.$route.params.account_id,
        ...reference_action,
        callback: res => {
          self.ref_action_id = null
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    destroyAction (reference_action) {
      let self = this
      this.ref_action_id = reference_action.reference_action_id

      this['reference/deleteAction']({
        account_id: self.$route.params.account_id,
        ...reference_action,
        callback: res => {
          self.ref_action_id = null
          if (res.error) {
            self.$message.error(res.error)
          } else {
            let index = self.Reference_Actions.findIndex(a => a.reference_action_id == reference_action.reference_action_id)
            if(index >= 0) self.Reference_Actions.splice(index, 1)
          }
        }
      })
    },
    openActionModal (type) {
      this.new_action.value = ''
      this.new_action.external_id = null
      this.new_action.type = type || 'user_attribute'
      this.validated = false
      this.action_modal = true
    },
    updateNextBlock (data) {
      this.next_block_action.external_id = data.next_block_id
      this.updateAction(this.next_block_action)
    },
    copy () {
      let self = this
      var dummy = document.createElement("textarea")
      document.body.appendChild(dummy)
      dummy.value = this.messenger_url + this.text
      dummy.select()
      document.execCommand("copy")
      document.body.removeChild(dummy)
      setTimeout(function () {
        self.$refs['copy-tooltip'].$emit('close')
      }, 1000);
    }
  },
  mounted () {
    this.reference_name = this.text
  }
}
</script>

<style lang="scss" scoped>
</style>
